import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SidebarContext } from "../../../context/SidebarContext";
import SectionMenuLeft from "../../../components/SectionMenuLeft/SectionMenuLeft.jsx";
import { ToastContainer, toast } from "react-toastify";
import "./SubAdminUpdate.css";
import { config } from "../../../config.js";
import { LuArrowLeft } from "react-icons/lu";

function SubAdminUpdate() {
  const { isSidebar } = useContext(SidebarContext);
  const { uid } = useParams();
  const navigate = useNavigate();

  const [subAdmin, setSubAdmin] = useState({
    name: "",
    username: "",
    email: "",
    city: "",
    password: "",
    active: false,
  });

  const [isLoading, setIsLoading] = useState(false);

  // Fetch sub-admin data
  const fetchSubAdmin = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}sub-admin/read/${uid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
        },
      );

      const result = await response.json();

      if (result.status && result.sub_admin) {
        const subAdminData = Array.isArray(result.sub_admin)
          ? result.sub_admin[0]
          : result.sub_admin;

        setSubAdmin({
          name: subAdminData.name || "",
          email: subAdminData.email || "",
          username: subAdminData.username || "",
          city: subAdminData.city || "",
          password: "",
          active: subAdminData.active || false,
        });
      } else {
        toast.error("Sub-admin not found");
      }
    } catch (error) {
      console.error("Fetching sub-admin failed:", error);
      toast.error("Failed to fetch sub-admin data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (uid) fetchSubAdmin();
  }, [uid]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSubAdmin((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}sub-admin/${uid}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
          body: JSON.stringify(subAdmin),
        },
      );

      const result = await response.json();

      if (response.ok && result.status) {
        toast.success("Sub-admin updated successfully!");
        setTimeout(() => {
          navigate("/admin/sub");
        }, 1000);
      } else {
        toast.error(result.message || "Failed to update sub-admin");
      }
    } catch (error) {
      console.error("Error updating sub-admin:", error);
      toast.error("Error updating sub-admin");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="body">
      <div id="wrapper">
        <div id="page">
          <div className="layout-wrap">
            <SectionMenuLeft />
            <div className="section-content-right">
              <div
                className="main-content"
                style={{ paddingLeft: isSidebar ? "280px" : "0px" }}
              >
                <div className="main-content-inner">
                  <div className="wg-box wg-box-container">
                    <ToastContainer />

                    <form
                      className="form-new-product form-style-1"
                      onSubmit={handleSubmit}
                    >
                      <div className="flex items-center justify-between mb-12 flex-wrap gap-3">
                        <div className="flex items-center gap-3">
                          <button
                            className="back-btn flex items-center gap-2"
                            onClick={() => navigate(-1)}
                          >
                            <LuArrowLeft size={16} />
                            {/* <span>Back</span> */}
                          </button>

                          <h5 className="fare-heading">Update Sub-Admin</h5>
                        </div>
                      </div>
                      <fieldset>
                        <div className="body-title">Name</div>
                        <input
                          type="text"
                          name="name"
                          value={subAdmin.name}
                          onChange={handleChange}
                          placeholder="name"
                          required
                        />
                      </fieldset>

                      <fieldset>
                        <div className="body-title">User Name</div>
                        <input
                          type="text"
                          name="username"
                          value={subAdmin.username}
                          onChange={handleChange}
                          placeholder="Username"
                          required
                        />
                      </fieldset>

                      <fieldset>
                        <div className="body-title">Email</div>
                        <input
                          type="email"
                          name="email"
                          value={subAdmin.email}
                          onChange={handleChange}
                          placeholder="Email"
                          required
                        />
                      </fieldset>

                      <fieldset>
                        <div className="body-title">City</div>
                        <input
                          type="text"
                          name="city"
                          value={subAdmin.city}
                          onChange={handleChange}
                          placeholder="City"
                        />
                      </fieldset>

                      <fieldset>
                        <div className="body-title">Password</div>
                        <input
                          type="password"
                          name="password"
                          value={subAdmin.password}
                          onChange={handleChange}
                          placeholder="Set new password"
                        />
                      </fieldset>

                      <fieldset>
                        <div className="body-title">Active</div>
                        <label className="switch">
                          <input
                            type="checkbox"
                            name="active"
                            checked={subAdmin.active}
                            onChange={handleChange}
                          />
                          <span className="slider round"></span>
                        </label>
                      </fieldset>

                      <div className="subBtnCon">
                        <button
                          type="submit"
                          className="btn"
                          disabled={isLoading}
                        >
                          {isLoading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubAdminUpdate;
